import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { createAction } from 'utils';

const defaultRedirectTo = '/home';

@connect(({ users }) => ({ ...users }))
class Login extends Component {
  componentDidMount() {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const code = params.get('token');
    const language = params.get('lang');
    const redirectTo = params.get('redirect_to') || defaultRedirectTo;
    const isEventRegister = params.get('is_event_register') === 'true';
    const verifyCredential = params.get('verify_credential');
    const countryCode = params.get('country_code');
    const mobile = params.get('mobile');
    const email = params.get('email');
    if (language) {
      this.props.dispatch({
        type: 'users/updateState',
        payload: { language: language },
      });
    }
    if (isEventRegister) {
      this.props.dispatch({
        type: 'users/updateState',
        payload: {
          eventRegistrationData: {
            verifyCredential,
            countryCode,
            phoneNumber: mobile,
            email,
            ignoreLogin: true,
          },
        },
      });
    }
    if (code) {
      // this.props.cookies.remove('user')
      console.log(code);
      this.props.dispatch(
        createAction('users/login')({
          code,
          successAction: () => {
            this.props.history.replace(redirectTo, { backToHome: true });
          },
          failAction: () => {
            this.props.history.replace(defaultRedirectTo);
          },
        }),
      );
    } else {
      this.props.history.replace(redirectTo, { backToHome: true });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.props.history.replace(defaultRedirectTo);
    }
  }

  render() {
    return (
      <div>
        {/* <pre id="content">
                    loading..
                </pre> */}
      </div>
    );
  }
}

export default withRouter(Login);
